import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  PF_CHROME_WEBAPP_APPLICATION_READY,
  PF_CHROME_WEBAPP_INITIATE_APPLICATION_CONTEXT,
  PF_CHROME_WEBAPP_UPDATE_RECIPIENT_NAMES,
  PF_CHROME_WEBAPP_ATTACH_CONTENT,
  INVALIDATE_ATTACH_CONTENT,
  SSO_AUTHENTICATION_SUCCESS,
  GENERATE_TOKEN_FOR_SSO_USER_SUCCEEDED,
  PF_CHROME_WEBAPP_POPULATE_MEETING_DETAILS,
  PF_CHROME_WEBAPP_INVALIDATE_MEETING_DETAILS,
  PF_ACTIVE_TAB_DETAILS,
  PF_CHROME_WEBAPP_POPULATE_DEAL_DETAILS
} from 'constants/actionTypes';

import { LINK_WIDGET } from 'constants/widgetTypes';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory
} from "react-router-dom";

import _ from 'lodash';

import AuthService from '../../services/auth.service';

import { activatedGmailIntegration, initiateApplicationContext, invalidateAssetSelection, invalidateSettings, setActiveTab } from 'actions/application';
import { fetchUserAccount, fetchUserProfile, logoutUser } from 'actions/users';
import { fetchIntegrations } from 'actions/integrations';
import {invalidateAttachContent, invalidateCollectionSelection, invalidateDealDetails, invalidateMeetingDetails, populateDealDetails, populateMeetingDetails, updateAttachContent, updateRecipientNames} from 'actions/selection'
import { guid } from 'services/util';
import EventService from 'services/event.service';

import SeekView from 'pages/seek'
import GmailView from 'pages/integrations/gmail';
import IntegrationView from 'pages/integrations';
import LoginView from 'pages/login';
import Conversations from 'components/conversations';
import FrequentlyShared from 'components/frequentlyShared';
import Notification from 'pages/notification';

import styles from './application.module.scss';
import AttachAsset from 'components/attachAsset';
import PaperfliteHome from 'components/paperfliteHome';
import RecommendedAssets from 'components/recommendedAssets';
import ConversationActivity from 'components/conversationActivity';
import Meeting from 'pages/meeting';
import { authenticateSSO, generateTokenForSSOUser } from 'actions/login';
import { fetchDeals, invalidateMeeting } from 'actions/meeting';
import ContentLibrary from 'pages/contentLibrary';

export default function ApplicationPage(props) {
  return (
    <Router>
      <ApplicationLoader>
        <Switch>
          <Route path="/" exact>
            <Redirect
              to={{
                pathname: "/home"
              }}
            />
          </Route>
          <Route path="/login" exact>
            <LoginView />
          </Route>

          <ProtectedRoute>
            <ChildrenView />
          </ProtectedRoute>

        </Switch>
      </ApplicationLoader>
    </Router>
  );
}

function ApplicationLoader({ children }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [loaded, setLoaded] = useState(false);

  const authenticated = useSelector(state => state.login.authenticated);
  const profile = useSelector((state) => _.get(state, 'users.profile.item') || null);

  const meeting = useSelector((state) => _.get(state, 'selection.meetingDetails') || {});

  useEffect(() => {
    if (authenticated) {
      window.parent.postMessage({
        type: "PAPERFLITE_AUTHENTICATION",
        refresh_token: AuthService.getRefreshToken(),
        access_token: AuthService.getAccessToken()
      }, '*');
    }
  }, [authenticated]);

  useEffect(() => {
    EventService.initialiseMixpanel();
    triggerMessageToPlugin({
      type: PF_CHROME_WEBAPP_APPLICATION_READY
    });

    window.addEventListener('message', (e) => messageListener(e));

    return () => {
      window.removeEventListener('message', (e) => messageListener(e));
    }
  }, []);

  useEffect(() => {
    if(_.size(meeting) > 0 && _.size(profile) > 0 && !_.isEmpty(meeting.attendeeIds)) {
      const userEmail = profile.email || "";
      const userDomain = userEmail.split("@")[1];
      const filteredEmails = meeting.attendeeIds.filter((email) => {
        const domain = email.split("@")[1];
        return domain && domain !== userDomain;
      });
      dispatch(fetchDeals({emails: filteredEmails}));
    }
  }, [meeting, profile]);

  const handlePopulateMeeting = (meetingDetails) => {
    if(_.isEmpty(meeting)) {
     dispatch(populateMeetingDetails(meetingDetails));
    }
  }

  const handlePopulateDeals = (dealDetails) => {
    if(_.isEmpty(meeting)) {
      dispatch(populateDealDetails(dealDetails));
    }
  }

  const navigateToPaperfliteHome = () => {
    history.push("/paperflite-home");
  }


  const messageListener = (e) => {
    const type = _.get(e.data, 'type');
    console.log(type);

    let accessToken, refreshToken, payload;

    switch (type) {
      case PF_CHROME_WEBAPP_INITIATE_APPLICATION_CONTEXT:
        payload = e.data.payload;

        if(_.get(payload, 'authentication.access_token') != null && _.get(payload, 'authentication.refresh_token') != null){
          accessToken = _.get(payload, 'authentication.access_token');
          refreshToken = _.get(payload, 'authentication.refresh_token');

          authenticateUser(payload, accessToken, refreshToken);
         
        } else {
          AuthService.clearAccessToken();
          AuthService.clearRefreshToken();
          dispatch(logoutUser(true, false));
        }
        
        dispatch(invalidateMeetingDetails());
        setLoaded(true);

        break;

        case PF_CHROME_WEBAPP_UPDATE_RECIPIENT_NAMES:
          const names = _.get(e.data.payload, "names") || [];
          dispatch(updateRecipientNames(names));
        break;

        case PF_CHROME_WEBAPP_ATTACH_CONTENT:
          var items;
          if(e.data.payload.collection){
            items = e.data.payload.collection;
          }else{
            var context = e.data.payload;
            items = e.data.payload.assets;
          }
          const html = e.data.payload.html;

          dispatch(updateAttachContent(context, items, html));
          dispatch(invalidateAttachContent());
          dispatch(invalidateAssetSelection());
          dispatch(invalidateCollectionSelection());


          break;

        case INVALIDATE_ATTACH_CONTENT:
          dispatch(invalidateAttachContent());
          dispatch(invalidateAssetSelection());
          dispatch(invalidateCollectionSelection());
          dispatch(invalidateSettings());

          break;

      
      case SSO_AUTHENTICATION_SUCCESS:

        payload = e.data.payload;

        accessToken = _.get(payload, 'access_token');
        refreshToken = _.get(payload, 'refresh_token');

        authenticateUser(payload, accessToken, refreshToken);

        setLoaded(true);
        dispatch(authenticateSSO());
        dispatch(generateTokenForSSOUser(refreshToken));
        
        break;
      
      case PF_CHROME_WEBAPP_POPULATE_MEETING_DETAILS: {
        dispatch(invalidateMeetingDetails());
        dispatch(invalidateMeeting());

        const meetingDetails = _.get(e.data.payload, 'meetingDetails', {});

        handlePopulateMeeting(meetingDetails)

        const dealDetails = _.get(e.data.payload, 'dealDetails', {});

        if(_.size(dealDetails) > 0) {
          handlePopulateDeals(dealDetails);
        }

        const currentUrl = window.location.pathname;
        if(!currentUrl.includes("paperflite-home") && currentUrl !== "/login"){
          navigateToPaperfliteHome();
        }
        break;
      }
      
      case PF_CHROME_WEBAPP_POPULATE_DEAL_DETAILS: {
        const dealDetails = e.data.payload;

        if(_.size(dealDetails) > 0) {
          handlePopulateDeals(dealDetails);
        } else {
          console.log("deals are not populated yet")
        }
        break;
      }

      case PF_CHROME_WEBAPP_INVALIDATE_MEETING_DETAILS:

        dispatch(invalidateMeetingDetails());
        dispatch(invalidateMeeting());

        break;

      case PF_ACTIVE_TAB_DETAILS: 
        const activeTab = e.data.payload.activeTab;
        const activated = e.data.payload.activated;

        dispatch(setActiveTab(activeTab));
        dispatch(activatedGmailIntegration(activated));
          
        if(activeTab){
          AuthService.saveActiveTab(activeTab);
          AuthService.saveGmailIntegrationStatus(activated);
        }

      break;

      default: {

      }
    }
  }

  const triggerMessageToPlugin = (message) => {
    window.parent.postMessage(message, "*");
  }

  const authenticateUser = (payload, accessToken, refreshToken) => {
    const integrationType = _.get(payload, 'context.type');

    if (integrationType != null) {
      AuthService.saveIntegrationType(integrationType.toUpperCase());
    }


    if (accessToken) {
      AuthService.saveToken(accessToken, refreshToken);
      console.log("payload", payload)
      let context = payload.context;
      
      if(context == null){
        context = {
          id: guid(),
          type: "sidepanel"
        }
      }
      dispatch(initiateApplicationContext(context));

      dispatch(fetchUserAccount());
      dispatch(fetchUserProfile());
      dispatch(fetchIntegrations());

    }
  }

  return (
    <div>
      {!loaded &&
        <div className={styles.content}>
          <div className={styles.loading}>Loading Profile {_.get(profile, 'firstName') || ''}...</div>
        </div>
      }

      {loaded && children}
    </div>
  );
}

function ChildrenView() {

  return (
    <Switch>
      <Route path="/home" exact>
        <PaperfliteHome />
      </Route>
      <Route path="/conversations" exact>
        <Conversations
          conversationLimit={25} />
      </Route>
      <Route path="/frequently-shared-assets" exact>
        <FrequentlyShared carousel={false} />
      </Route>
      <Route path="/frequently-used" exact>
        <FrequentlyShared attachAssets={true} />
      </Route>
      <Route path="/content-library" exact>
        <ContentLibrary />
      </Route>
       <Route path="/paperflite-content-library" exact>
        <ContentLibrary />
      </Route>
      <Route path="/gmail" exact>
        <GmailView />
      </Route>
      <Route path='/freshsales' exact>
        <IntegrationView />
      </Route>
      <Route path='/salesforce' exact>
        <IntegrationView />
      </Route>
      <Route path='/hubspot' exact>
        <IntegrationView filterWidgets={(widget) => _.includes([LINK_WIDGET], widget)} />
      </Route>
      <Route path='/outreach' exact>
        <IntegrationView filterWidgets={(widget) => _.includes([LINK_WIDGET], widget)} />
      </Route>
      <Route path='/klenty' exact>
        <IntegrationView />
      </Route>
      <Route path='/pipedrive' exact>
        <IntegrationView />
      </Route>
      <Route path='/zoho' exact>
        <IntegrationView />
      </Route>
      <Route path='/salesloft' exact>
        <IntegrationView />
      </Route>
      <Route path='/netsuite' exact>
        <IntegrationView />
      </Route>
      <Route path='/ms_dynamics' exact>
        <IntegrationView />
      </Route>
      <Route path="/notification" exact>
        <Notification logout = {true} />
      </Route>
      <Route path="/paperflite-notification" exact>
        <Notification logout = {false} />
      </Route>
      <Route path="/seek" exact>
        <SeekView />
      </Route>
      <Route path="/paperflite-home">
        <PaperfliteHome />
      </Route>
      <Route path="/attachAssets">
        <AttachAsset />
      </Route>
      <Route path="/recommended-assets">
        <RecommendedAssets />
      </Route>
      <Route path="/conversations">
        <Conversations />
      </Route>
      <Route path="/conversation-activity">
        <ConversationActivity />
      </Route>
      <Route path="/meeting-prep">
        <Meeting />
      </Route>
    </Switch>
  )
}

function ProtectedRoute({ children, ...rest }) {
  var authenticated = AuthService.isAuthenticated();

  return (
    <Route {...rest}
      render={() =>
        authenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login"
            }}
          />
        )
      }
    />
  );
}